import React from "react";
import htmlToPdf from "html-to-pdf-js";
import { addHeaderFooterToPDF } from "./addHeaderFooter";

export const generatePDF = (htmlContent, company, fileName) => {
  const options = {
    margin: company !== "Samde" ? [24, 10, 32, 10] : [35, 10, 10, 10], // 10mm top and bottom margins, 0mm left and right
    filename: `${fileName}.pdf`,
    html2canvas: {
      scale: 2, // Increase resolution of the content
    },
    jsPDF: {
      unit: "mm",
      format: "a4",
    },
    pagebreak: { mode: ["avoid-all", "css", "legacy"] }, // Ensure page breaks work well
    header: {
      // height: '10%',
    },
    footer: {
      // height: '10%'
    },
  };

  htmlToPdf()
    .from(htmlContent)
    .set(options)
    .outputPdf("blob") // Get PDF as Blob instead of saving directly
    .then((pdfBlob) => {
      // Log the Blob data to console
      // console.log('PDF Blob:', pdfBlob);
      let headerImage = "";
      let footerImage = "";

      if (company === "Banwari") {
        headerImage = require("../images/coa/banwari_header1.png"); // Path to header image
        footerImage = require("../images/coa/banwari_footer.png"); // Path to footer image
      }
      if (company === "Samde") {
        headerImage = require("../images/coa/samde_header.png"); // Path to header image
      }
      if (company === "Petorose") {
        headerImage = require("../images/coa/petorose_header.png"); // Path to header image
        footerImage = require("../images/coa/petrose_footer2.png"); // Path to footer image
      }

      addHeaderFooterToPDF(
        pdfBlob,
        headerImage,
        footerImage,
        company,
        fileName
      );

      // // Create a download link manually
      // const link = document.createElement('a');
      // link.href = URL.createObjectURL(pdfBlob);
      // link.download = options.filename;
      // link.click();

      // console.log('PDF generated and downloaded.');
    })
    .catch((error) => {
      console.error("Error generating PDF:", error);
    });
};
export const generatePDFWithOut = (htmlContent, fileName, company) => {
  const margins = {
    Banwari: [42, 10, 38, 10],
    Samde: [42, 10, 38, 10],
    Petorose: [42, 10, 38, 10],
  };

  const options = {
    margin: margins[company] || [10, 10], // 10mm top and bottom margins, 0mm left and right
    filename: `${fileName}.pdf`,
    html2canvas: {
      scale: 2, // Increase resolution of the content
    },
    jsPDF: {
      unit: "mm",
      format: "a4",
    },
    pagebreak: { mode: ["avoid-all", "css", "legacy"] }, // Ensure page breaks work well
  };

  htmlToPdf()
    .from(htmlContent)
    .set(options)
    .outputPdf("blob") // Get PDF as Blob instead of saving directly
    .then((pdfBlob) => {
      // Log the Blob data to console
      console.log("PDF Blob:", pdfBlob);

      // // Create a download link manually
      const link = document.createElement("a");
      link.href = URL.createObjectURL(pdfBlob);
      link.download = options.filename;
      link.click();

      // console.log('PDF generated and downloaded.');
    })
    .catch((error) => {
      console.error("Error generating PDF:", error);
    });
};

// Example usage in a React component
// const App = () => {

//   return (
//     <div>
//       <div id="pdfContent">
//         {/* Your HTML content goes here */}
//       </div>
//       <button onClick={handleDownload}>Download PDF</button>
//     </div>
//   );
// };

// export default App;
